// Roomy Tiny House - EN/TR çeviri sözlüğü (sadece aktif sayfalar).
// HTML içeren değerler (<br/> vb.) bileşende html-react-parser ile parse edilir.

const translations = {
  tr: {
    nav: {
      home: "Ana Sayfa",
      about: "Hakkımızda",
      photos: "Fotoğraflar",
      videos: "Videolar",
      contact: "Bize Ulaşın",
      reserve: "Rezervasyon",
    },
    breadcrumb: { home: "Ana Sayfa" },
    pageTitles: {
      about: "Hakkımızda",
      photos: "Fotoğraflar",
      videos: "Videolar",
      contact: "Bize Ulaşın",
    },
    banner: {
      subtitle: "Roomy Tiny House",
      slide1Title: "Roomy Tiny House",
      slide1Text:
        "Size en kaliteli hizmeti sunmaya çalışıyoruz.<br/>Isıtmalı havuz 🏊‍♂️<br/>Jakuzi 🛀<br/>Barbekü 🍽<br/>Müstakil Tiny House 🏠<br/>",
      slide2Title: "Hayalinizdeki Tiny <br/> House",
      slide2Text:
        "Rüya gibi tatiller için benzersiz bir deneyim yaşayın!<br/>Şimdi rezervasyon yapın ve doğanın kucağında sakin bir mola için yerinizi ayırtın.",
      slide3Title: "Roomy Tiny House'da Gece Ayrı Güzel",
      slide3Text: "Size en kaliteli hizmeti sunmaya çalışıyoruz.",
      reserve: "Rezervasyon",
      photos: "Fotoğraflarımız",
      contact: "Bize Ulaşın",
    },
    homeAbout: {
      subtitle: "Hakkımızda",
      title: "Sapancada Huzurlu Kaçış",
      intro:
        "Sapancada kırsal alanın kucağında, özel bahçesi ve çift kişilik jakuzi ile donatılmış müstakil tiny house'umuzda unutulmaz bir tatil sizi bekliyor.",
      f1Title: "Temizlik ve Hijyen",
      f1Text: "Siz gelmeden önce tiny house'umuzu titizlikle temizliyoruz.",
      f2Title: "Misafir Destek",
      f2Text: "Sizin için hazır olan misafir destek hattımız.",
      f3Title: "Konum",
      f3Text: "Sapanca Gölü'ne sıfır konumumuzla eşsiz bir deneyim yaşayın.",
    },
    gallery: {
      subtitle: "TinyHouse",
      title: "TinyHouse Fotoğraflarımız",
      c1Sub: "Dış Bahçe",
      c1Title: "Bahçemiz",
      c1Text:
        "Tiny house, özel bir bahçe içerisinde konumlanmıştır, böylece misafirler doğanın tadını çıkarabilir ve gizliliklerinin keyfini sürebilirler.",
      c2Sub: "İç Alan",
      c2Title: "TinyHouse",
      c2Text:
        "Roomy Tiny House'un iç mekanı, minimalizmin ve rahatlığın harika bir birleşimini sunar. Rahat oturma alanı, özel yatak, akıllı TV ve klimalı bir ortam içerir.",
      c3Sub: "Isıtmalı Havuz",
      c3Title: "Isıtmalı Havuz",
      c3Text:
        "Isıtmalı havuz ve jakuzi, misafirlerin konforunu üst düzeye çıkarmak için tasarlanmış lüks özelliklerdir. Roomy Tiny House benzersiz bir konaklama deneyimi sunar.",
    },
    services: {
      title: "Hizmetlerimiz",
      s1Title: "Park Alanı",
      s1Text: "Özel park alanı hizmetimiz bulunmaktadır.",
      s2Title: "Isıtmalı Havuz",
      s2Text: "Isıtmalı havuz ve jakuzimiz bulunmaktadır.",
      s3Title: "Güvenlik",
      s3Text: "7/24 güvenlik hizmetimiz vardır.",
      s4Title: "Konforlu Yatak",
      s4Text: "4 kişilik yatak hizmetimiz bulunmaktadır.",
    },
    aboutPage: {
      subtitle: "Hakkımızda",
      title: "Sakarya Sapanca'da Roomy Tiny House keyfi",
      text:
        "Sapanca Gölü'ne sıfır, özel bahçesi ve çift kişilik jakuzi ile donatılmış müstakil tiny house'umuzda unutulmaz bir tatil sizi bekliyor. Isıtmalı havuzda serinleyin, akıllı TV'de favori dizilerinizi izleyin veya özel otoparkımızda aracınızı rahatça park edin. Wi-Fi ile bağlantıda kalın ve barbekü keyfini çıkarın. Kahvaltı dahil, mutfak araç gereçleri mevcut. Evcil hayvan kabul edilmez. Giriş 14:00, Çıkış 11:00.",
      li1: "Kompakt Ev Dizaynı",
      li2: "Merkezi Konum",
      li3: "Olağanüstü Yaşam Tarzı",
      li4: "24/7 Güvenlik",
      callout: "\"Konaklama randevularınızı WhatsApp'tan alabilirsiniz\"",
      reserve: "WhatsApp Rezervasyon",
    },
    cta: {
      title: "Hayalinizdeki Tiny House'a mı baktınız?",
      text: "Sizin için en konforlu hizmeti veriyoruz.",
      btn: "Roomy Tiny House'u Keşfet",
    },
    contact: {
      emailTitle: "E-posta Adresimiz",
      phoneTitle: "Telefon Numarası",
      locationTitle: "Konumumuz",
      reserve: "WhatsApp Rezervasyon",
      locationBtn: "Konum",
    },
    galleryPage: {
      interior: "İç Mekan",
      interiorSub: "Estetik Görünüm & Kompakt",
      exterior: "Dış Mekan",
      sink: "Lavabo",
      kitchenArea: "Mutfak Bölümü",
      kitchenAreaSub: "Hijyenik & Kullanışlı",
      bedroom: "Yatak Odası",
      bedroomSub: "Temiz & Kullanışlı",
      livingRoom: "Salon",
      livingRoomSub1: "Konforlu & Rahat",
      livingRoomSub2: "Sıcak & Keyifli",
      livingRoomSub3: "Ferah & Huzurlu",
      kitchen: "Mutfak",
      kitchenSub: "Kompakt & Konforlu",
      videos: "Videolarımız",
    },
    footer: {
      tagline: "Sapancada Huzurlu Kaçış: Müstakil Bahçeli Jakuzulu Tiny House.",
    },
    copyright: "Tüm Hakları Saklıdır @ Roomy Tiny House",
  },

  en: {
    nav: {
      home: "Home",
      about: "About",
      photos: "Photos",
      videos: "Videos",
      contact: "Contact",
      reserve: "Book Now",
    },
    breadcrumb: { home: "Home" },
    pageTitles: {
      about: "About Us",
      photos: "Photos",
      videos: "Videos",
      contact: "Contact Us",
    },
    banner: {
      subtitle: "Roomy Tiny House",
      slide1Title: "Roomy Tiny House",
      slide1Text:
        "We strive to offer you the highest quality service.<br/>Heated pool 🏊‍♂️<br/>Jacuzzi 🛀<br/>Barbecue 🍽<br/>Private Tiny House 🏠<br/>",
      slide2Title: "The Tiny House <br/> of Your Dreams",
      slide2Text:
        "Enjoy a unique experience for dream-like holidays!<br/>Book now and reserve your spot for a peaceful break in the heart of nature.",
      slide3Title: "Nights Are Even Better at Roomy Tiny House",
      slide3Text: "We strive to offer you the highest quality service.",
      reserve: "Book Now",
      photos: "Our Photos",
      contact: "Contact Us",
    },
    homeAbout: {
      subtitle: "About Us",
      title: "A Peaceful Escape in Sapanca",
      intro:
        "An unforgettable holiday awaits you in our private tiny house, nestled in the countryside of Sapanca, featuring a private garden and a two-person jacuzzi.",
      f1Title: "Cleanliness & Hygiene",
      f1Text: "We meticulously clean our tiny house before your arrival.",
      f2Title: "Guest Support",
      f2Text: "Our guest support line is always ready for you.",
      f3Title: "Location",
      f3Text: "Enjoy a unique experience right next to Lake Sapanca.",
    },
    gallery: {
      subtitle: "TinyHouse",
      title: "Our TinyHouse Photos",
      c1Sub: "Outdoor Garden",
      c1Title: "Our Garden",
      c1Text:
        "The tiny house is set within a private garden, so guests can enjoy nature and savor their privacy.",
      c2Sub: "Interior",
      c2Title: "TinyHouse",
      c2Text:
        "The interior of Roomy Tiny House offers a wonderful blend of minimalism and comfort. It features a cozy seating area, a private bed, a smart TV and air conditioning.",
      c3Sub: "Heated Pool",
      c3Title: "Heated Pool",
      c3Text:
        "The heated pool and jacuzzi are luxury features designed to maximize guest comfort. Roomy Tiny House offers a unique stay experience.",
    },
    services: {
      title: "Our Services",
      s1Title: "Parking Area",
      s1Text: "We provide a private parking area.",
      s2Title: "Heated Pool",
      s2Text: "We have a heated pool and jacuzzi.",
      s3Title: "Security",
      s3Text: "We offer 24/7 security service.",
      s4Title: "Comfortable Beds",
      s4Text: "We provide bedding for 4 guests.",
    },
    aboutPage: {
      subtitle: "About Us",
      title: "The Roomy Tiny House experience in Sapanca, Sakarya",
      text:
        "An unforgettable holiday awaits you in our private tiny house right next to Lake Sapanca, featuring a private garden and a two-person jacuzzi. Cool off in the heated pool, watch your favorite shows on the smart TV, or park your car comfortably in our private parking. Stay connected with Wi-Fi and enjoy the barbecue. Breakfast included and kitchen utensils available. Pets are not allowed. Check-in 14:00, Check-out 11:00.",
      li1: "Compact Home Design",
      li2: "Central Location",
      li3: "Extraordinary Lifestyle",
      li4: "24/7 Security",
      callout: "\"You can make your reservation via WhatsApp\"",
      reserve: "Book via WhatsApp",
    },
    cta: {
      title: "Found the tiny house of your dreams?",
      text: "We provide the most comfortable service for you.",
      btn: "Discover Roomy Tiny House",
    },
    contact: {
      emailTitle: "Our Email Address",
      phoneTitle: "Phone Number",
      locationTitle: "Our Location",
      reserve: "Book via WhatsApp",
      locationBtn: "Location",
    },
    galleryPage: {
      interior: "Interior",
      interiorSub: "Aesthetic Look & Compact",
      exterior: "Exterior",
      sink: "Sink",
      kitchenArea: "Kitchen Area",
      kitchenAreaSub: "Hygienic & Practical",
      bedroom: "Bedroom",
      bedroomSub: "Clean & Practical",
      livingRoom: "Living Room",
      livingRoomSub1: "Comfortable & Relaxing",
      livingRoomSub2: "Warm & Pleasant",
      livingRoomSub3: "Spacious & Peaceful",
      kitchen: "Kitchen",
      kitchenSub: "Compact & Comfortable",
      videos: "Our Videos",
    },
    footer: {
      tagline: "A Peaceful Escape in Sapanca: Private Tiny House with Garden & Jacuzzi.",
    },
    copyright: "All Rights Reserved @ Roomy Tiny House",
  },
};

export default translations;
